import { generateTableSlice } from "./sliceTable";

const sliceCaregiversReportTable = generateTableSlice("caregiversReport");

export const ActionsCaregiversReport = sliceCaregiversReportTable.actions;
export const ReducerCaregiversReport = sliceCaregiversReportTable.reducer;
